import React from "react";
import arrowIcon from "@assets/svg/arrow-black.svg?url";

type BonusCardProps = {
  icon: React.ReactNode;
  description: string;
  link: string;
  target?: "_blank" | "_self";
};

const BonusCard: React.FC<BonusCardProps> = ({
  icon,
  description,
  link,
  target = "_self",
}) => (
  <div className="border-l border-grey-lighter pl-[12px] md:pl-[24px] text-sm relative h-full">
    <div className="mb-2">{icon}</div>

    <div className="max-w-[170px]">{description}</div>

    <a
      href={link}
      target={target}
      className="absolute bottom-0 border-b border-[#323232] text-sm cursor-pointer font-semibold pb-2"
    >
      Explore <img className="ml-2 inline" src={arrowIcon} alt="arrow" />
    </a>
  </div>
);

export default BonusCard;
